import { render, staticRenderFns } from "./ContactData.vue?vue&type=template&id=3554e354"
import script from "./ContactData.vue?vue&type=script&lang=js"
export * from "./ContactData.vue?vue&type=script&lang=js"
import style0 from "./ContactData.vue?vue&type=style&index=0&id=3554e354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports